import React from 'react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { selectIsSmallScreen } from 'store/pageStore';
import { stepNumberStyles, stepStyles, stepTitleStyles } from './styles';
import { Step as StepType } from '../../steps-db';

export const Step = ({ number, title, titleMob, description }: StepType) => {
	const isSmallScreen = useSelector(selectIsSmallScreen);
	return (
		<div className={stepStyles}>
			<Typography variant="h3" className={stepNumberStyles}>
				{number}
			</Typography>
			<Typography className={stepTitleStyles} variant="h3">
				{isSmallScreen ? titleMob : title}
			</Typography>
			<Typography variant="m" size="body_long">
				{description}
			</Typography>
		</div>
	);
};
